import { render, staticRenderFns } from "./Press.vue?vue&type=template&id=3c38129c&scoped=true&"
import script from "./Press.vue?vue&type=script&lang=js&"
export * from "./Press.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38129c",
  null
  
)

export default component.exports